module.exports = __webpack_public_path__ + "static/template-home-about-hero-background-973495057fc6fe34dca65feb97432ba2.jpg";